// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import DTTable from '../../components/AntdTable';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { notification } from 'antd';
import ModalForm from '../../components/ModalForm';
import { useTranslation } from 'react-i18next';

const Report = () => {
  const { t } = useTranslation();
  const [report, setReport] = useState([]);
  const [link, setLink] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL
  const [executionTime, setExecutionTime] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);
  //console.log('user_id:',user_id)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const startTime = Date.now(); // Start time for the request

        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/${route}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        console.log('response.data.report:', response.data.report);
        setLink(response.data?.link);
        if (response.data.report.errno) {
          notification.error({ message: response.data.report.sqlMessage });
        } else {
          setReport(response.data?.report);
          setPermissions(response.data?.permissions);
        }
        const endTime = Date.now(); // End time for the request
        setExecutionTime(endTime - startTime); // Calculate the execution time

        setLoading(false);
        document.title = response.data.link?.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        // notification.error({ message: error.message });
        notification.error({
          message: `Error ${error.response.status}: ${error.response.data.message || 'Unknown error'}`,
        });
        setLink([]);
        setReport([]);
        setLoading(false);
      }
    };

    fetchData();
  }, [route]);

  //console.log('report link:', link);

  return (
    <>
      <br />
      {link?.reg_route && (
        <div className="">
          <center>
            {link.reg_route.split(',').map((route, index) => (
              <>
                <button
                  key={index}
                  className="btn btn-primary"
                  onClick={() => openModal2(route.trim())} // Pass the specific route to the modal
                >
                  {t(link.reg_name.split(',')[index])}
                </button>{' '}
                &nbsp;
              </>
            ))}
          </center>
          {isModalOpen && currentRoute && (
            <ModalForm
              userId={userId}
              token={token}
              route={currentRoute} // Pass the dynamic route to the modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
            />
          )}
        </div>
      )}
      {report && report.length === 0 && <p>No Data </p>}
      <DTTable
        data={report}
        link={link}
        token={token}
        executionTime={executionTime}
        editDelPermission={permissions}
      />
      )
    </>
  );
};

export default Report;
